import React, { useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { isNotEmpty, NSchange, parseVideo } from '../../lib/ep.js';

import ActionButton, { BackButton } from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection.js';
import Checkbox from '../builder/Checkbox.js';
import ConfirmButton from '../builder/ConfirmButton.js';
import DisabledArea from '../builder/DisabledArea';
import ImageUploader from '../builder/ImageUploader';
import Input from '../builder/Input';
import MediaUploader from '../builder/MediaUploader';
import Model from '../builder/Model';
import RichEditor from '../builder/RichEditor';
import SectionSubtitle from '../builder/SectionSubtitle';
import TextArea from '../builder/TextArea';
import Tooltip from '../builder/Tooltip.js';
import UrlField from '../builder/UrlField';

const QuizResultOptions = (props) => {
	const [ errors, setErrors ] = useState({});
	const [ viral, setViral ] = useState(false);

	const change = (k, v) => {
		if(k == 'image' && v == null) v = '';
		if(k == 'full_image' && v == null) v = '';
		if(k == 'share_image' && v == null) v = '';
		if(k == 'fullshare_image' && v == null) v = '';
		if(k == 'video' && v != '') v = parseVideo(v);

		if(k == 'min' && props.pm.quiz_score_type == '1') {
			NSchange(props.qr.QuizResult, 'max', v);
		}

		// quiz result rank
		if(k == 'min' || k =='max') {
			if(k == 'min' && parseInt(v) > parseInt(props.qr.QuizResult.max)) {
				setErrors({ min:"Min value must be lower than max value" });
				return
			}

			if(k == 'max' && parseInt(v) < parseInt(props.qr.QuizResult.min)) {
				setErrors({ max:"Min value must be lower than max value" });
				return
			}

			const cid = props.qr.QuizResult.id;

			for(let i in props.results) {
				const c = props.results[i].QuizResult;
				const min = parseInt(c.min);
				const max = parseInt(c.max);
				const vint = parseInt(v);

				if(c.id == cid) continue;

				if(k == 'min') {
					if(vint >= min && vint <= max) {
						setErrors({ min:"Minimum value has already been used in another final message" });
						return;
					}
				}

				if(k == 'max') {
					if(vint <= max && vint >= min) {
						setErrors({ max:"Maximum value has already been used in another final message" });
						return;
					}
				}
			}
		}

		NSchange(props.qr.QuizResult, k, v);
		setErrors({});

		if(props.onChange !== undefined) props.onChange();

		if(k == 'message') change('message_st', v);
	};

	const qr = props.qr.QuizResult;
	const video_url = (qr.video != undefined) ? qr.video.url : '';

	const pm = props.pm;
	const share_options = props.share_options ;
	const share_enabled = (share_options.status == '1') ? true : false;
	const networks = share_options?.networks ?? {};

	const share_networks = {
		facebook:((networks.facebook == undefined || networks.facebook == '1') ? true : false),
		line:((networks.line == undefined || networks.line == '1') ? true : false),
		mail:((networks.mail == undefined || networks.mail == '1') ? true : false),
		pinterest:((networks.pinterest == undefined || networks.pinterest == '1') ? true : false),
		linkedin:((networks.linkedin == undefined || networks.linkedin == '1') ? true : false),
		telegram:((networks.telegram == undefined || networks.telegram == '1') ? true : false),
		twitter:((networks.twitter == undefined || networks.twitter == '1') ? true : false),
		whatsapp:((networks.whatsapp == undefined || networks.whatsapp == '1') ? true : false),
	};

	const hash = window.location.hash.substring(1);

	const hash_value = hash.split("&").reduce((res, item) => {
		const parts = item.split('=');
		return parts[0];
	}, {});
	
	const is_new = (hash_value.indexOf('/new') > -1) ? true : false;

	if(viral) {
		return (
			<div>
				<ButtonCollection _class={{other:'submenu_builder_sidebar'}}>
					<BackButton
						id="viral"
						onClick={() => setViral(false)}
					/>
				</ButtonCollection>

				<div>
					<SectionSubtitle
						_class={{ other:'in_top' }}
					>Viral message used when users shares their Quiz result</SectionSubtitle>

					<Model
						model={qr}
						change={change}
					>
						<Input
							name="share_title"
							_class={{ first:true }}
						>Title</Input>

						<TextArea
							name="share_description"
							max_length={255}
						>Description</TextArea>

						<ImageUploader
							name="share_image"
							label_props={{
								tooltip:<Tooltip>Use an image that describes this final message</Tooltip>,
							}}
							image={qr.fullshare_image}
							_size={{ width:1200, height:630 }}
						>Viral image</ImageUploader>
					</Model>

					<DisabledArea
						disabled={((!share_networks.twitter) ? true : false)}
						message="Twitter network must be enabled"
					>
						<Model
							model={qr}
							change={change}
						>
							<TextArea
								name="share_twitter"
								max_length={280}
							>Tweet</TextArea>
						</Model>
					</DisabledArea>

					<DisabledArea
						disabled={((!(share_networks.line || share_networks.telegram || share_networks.whatsapp)) ? true : false)}
						message="Whatsapp, Telegram or Line networks must be enabled."
					>
						<Model
							model={qr}
							change={change}
						>
							<TextArea
								name="post_instant"
								max_length={200}
							>Instant Messaging Apps (Whatsapp, Telegram, Line)</TextArea>
						</Model>
					</DisabledArea>
				</div>
			</div>
		)
	}

	return (
		<div>
			<ButtonCollection
				_class={{ other:'submenu_builder_sidebar' }}
			>
				{(is_new) ? (
					<ConfirmButton
						id="nonviral"
						icon='knk-go-prev'
						secondary={true}
						_position="bottomright"
						onClick={() => { window.location.hash = `${props.base}results`; }}
					>Back</ConfirmButton>
				): (
					<BackButton
						id="nonviral"
						onClick={() => { window.location.hash = `${props.base}results`; }}
					/>
				)}

				{(share_enabled) && (
					<ActionButton
						icon='knk-share'
						onClick={() => setViral(true)}
					>Share options</ActionButton>
				)}
			</ButtonCollection>

			<Model
				model={qr}
				change={change}
				errors={errors}
			>
				<MediaUploader
					auto_url={`/quizs/auto_img/${pm.id}`}
					auto_type='quizresult'
					_class={{ first:true }}
					imageField="image"
					videoField="video"
					image={(qr.image) ? qr.fullimage : ''}
					video={video_url}
					_size={{ fit:'auto' }}
				>Upload media</MediaUploader>

				<RichEditor
					name="message"
					has_emojis={true}
					after_component={<span class="knk-tip">
						<FormattedMessage
							id="You can include {tag} in the message to show the score or number of correct answers of the user."
							values={{
								tag:`{{score}}`,
							}}
						/>
					</span>}
				>Final message</RichEditor>

				<Input
					name="min"
					_type="number"
				>{(pm.quiz_score_type == '1') ? "Value" : "Min. points or correct answers"}</Input>

				{(pm.quiz_score_type != '1') && (
					<Input
						name="max"
						_type="number"
					>Max. points or correct answers</Input>
				)}

				<UrlField
					name="cta_url"
					error_msg_position_class=""
				>Final button URL</UrlField>

				{(isNotEmpty(qr, 'cta_url')) && (
					<Input
						name="cta_label"
						placeholder="Click here"
					>Final button label</Input>
				)}

				{(['3', '4'].includes(props.pm.login_type)) && (
					<Checkbox
						name="disable_continue"
					>Do not show the continue button</Checkbox>
				)}
			</Model>
		</div>
	);
};

export default injectIntl(QuizResultOptions);